import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { MyProfilePageService } from '@pages/MyProfilePage/services';

const MODULE_NAME = 'profile.machines.states.updateProfile';

const getSrv = () => {
  return vappContainer.get<MyProfilePageService>(
    MyProfilePageService.displayName
  );
};

export const updateProfile = async (context: any, event: any) => {
  const currentState = 'UPDATE_PROFILE';
  const method = 'updateProfile';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getUpdateProfile(event?.payload);
      if (content) {
        return resolve({
          key: 'UPDATE_PROFILE_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'UPDATE_PROFILE_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'UPDATE_PROFILE_FAILED',
        value: err?.message,
      });
    }
  });
};
